var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBcd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.37 2.5h11.773l.122.076 4 2.5.08.05.055.074 4.5 6 .24.32-.26.304-14.5 17-.46.54-.262-.456-.24-.286L2.188 12.896 1 11.547l.96-1.252 3.633-5.086.066-.092.097-.055 4.5-2.5.113-.063zm18.257 10.426-10.773 12.63 5.507-10.173 5.266-2.457zm1.103-1.619-4.014-5.352-.154.073-3.497 1.748 1.3 6.502 6.365-2.97zM11.368 8h9.722l1.384 6.92-6.647 12.28-6.784-11.76L11.368 8zm-3.236 7.862 4.673 8.101L3.81 13.27l4.322 2.592zm2.25-8.06-2.17 6.942-5.74-3.444 3.707-5.19 4.028 1.612.174.08zM11.096 7 7.162 5.426 10.63 3.5h11.227l2.9 1.813L21.382 7H11.096zm8.26 6.347c-.038 1.135-.776 1.825-.776 1.825 1.088.075 1.56.926 1.286 2.571-.274 1.627-3.072 1.55-3.072 1.55v1.675h-.937v-1.636h-.775v1.635h-1.011v-1.71H12v-1.164s.634.038.983 0c.35-.038.312-.35.312-.35s-.038-3.696 0-4.358c.038-.662-.387-.624-.387-.624H12v-1.087l1.995-.075V10h1.05v1.674h.775V10h1.011v1.674c2.29-.038 2.564.586 2.526 1.673zm-1.863.463c-.075-1.437-2.524-.974-2.524-.974v1.948c-.001 0 2.599.463 2.523-.974zm-2.524 4.312c-.001 0 2.996.5 2.996-1.286 0 0 .19-1.173-2.997-.898v2.184z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcd);
export default __webpack_public_path__ + "static/media/BCD.d07e8a319428c775ddfe27636fcb354d.svg";
export { ForwardRef as ReactComponent };